export enum UserPermissionFlag {
  USER = 'user',
  ADMIN = 'admin',
  MANAGER = 'manager',
}

export type User = {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
  address: string;
  city: string;
  state: string;
  postalCode: string;
  province: string;
  countryCode: string;
  permissionFlag: UserPermissionFlag;
  newsletter: boolean;
  clientNewsletter: boolean;
  oauthProvider: string | null;

  isMember: boolean;
  membershipCreatedAt: string;
  isSubscribed: boolean;

  createdAt: string;
  updatedAt: string;
}
